exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link{color:#201350 !important}.nav-link:hover{color:#473391 !important}.nav-link.active{font-weight:500}\n", ""]);

// exports
